var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAmenityMuseum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-489 491 100 125",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-483 591h88c4 0 4 0 4-4s0-4-4-4h-88c-4 0-4 0-4 4s0 4 4 4zm76-16h2c4 0 4 0 4-4v-40c0-4 0-4-4-4h-2c-4 0-4 0-4 4v40c0 4 0 4 4 4zm-22 0h2c4 0 4 0 4-4v-40c0-4 0-4-4-4h-2c-4 0-4 0-4 4v40c0 4 0 4 4 4zm-22 0h2c4 0 4 0 4-4v-40c0-4 0-4-4-4h-2c-4 0-4 0-4 4v40c0 4 0 4 4 4zm-22 0h2c4 0 4 0 4-4v-40c0-4 0-4-4-4h-2c-4 0-4 0-4 4v40c0 4 0 4 4 4zm34-62c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm-44 6h88c4 0 4 0 4-4v-2c0-2 0-2-4-4l-44-18-44 18c-4 2-4 2-4 4v2c0 4 0 4 4 4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenityMuseum);
export default __webpack_public_path__ + "static/media/amenity_museum.0806062a4b37536eea8354b8184b49f4.svg";
export { ForwardRef as ReactComponent };